import React from 'react';
import SectionKicker from './SectionKicker';
import ServicesGrid from './ServicesGrid';

function ServicesPreview() {
  return (
    <section className="section" id="services">
      <div className="center-heading">
        <SectionKicker tone={0}>What we handle</SectionKicker>
        <h2>Every call answered.<br /><em>Every lead followed up.</em></h2>
      </div>
      <ServicesGrid featuredOnly />
      <p className="service-note">
        <a className="footer-link" href="#/services">See all 13 services</a>
      </p>
    </section>
  );
}

export default ServicesPreview;
